import React from 'react';
import { useSelector, useDispatch } from 'react-redux'
import Modal from 'react-modal';
import CloseIcon from '../../assets/icons/CloseIcon/CloseIcon'
import * as actions from './ModalAlert.actions';

const ModalAlert = () => {
  const dispatch = useDispatch();
  const store = useSelector(store => store)
  const alertCallback = store.alert.callback

  Modal.setAppElement('body');

  const okButtonHandler = () => {
    if (alertCallback) alertCallback(true)

    dispatch(actions.hideAlert())
  }

  const cancelButtonHandler = () => {
    if (alertCallback) alertCallback(false)

    dispatch(actions.hideAlert())
  }

  return (
    <Modal 
      isOpen={ store.alert.isOpen } 
      className={ `coral-Modal ${ (store.alert.isOpen) ? 'coral-Modal-open' : '' }` }
      overlayClassName="coral-Modal-backdrop"
    >
      <div className="coral-Modal-header">
        <h2 className="coral-Modal-title coral-Heading coral-Heading--2">
          { store.alert.header }
        </h2>
        <button 
          className={ `coral-MinimalButton coral-Modal-closeButton ${ (store.alert.hideCloseButton) ? 'hidden' : '' }` }
          onClick={ cancelButtonHandler }
        >
          <CloseIcon 
            width="12" 
            height="12" 
          />
        </button>
      </div>
      <div className="coral-Modal-body coral-Modal-body_center">
        <p>{ store.alert.body }</p>
      </div>
      <div className="coral-Modal-footer coral-Modal-footer_center">
        { (store.alert.cancelButtonText.length) ? (
            <button 
              className="coral-Button primary"
              onClick={ cancelButtonHandler }
            >
              { store.alert.cancelButtonText }
            </button>
          ) : ( 
            <div></div>
          )
        }
        { (store.alert.okButtonText.length) ? (
            <button 
              className="coral-Button" 
              onClick={ okButtonHandler }
            >
              { store.alert.okButtonText }
            </button>
          ) : (
            <div></div>
          )
        }
      </div>
    </Modal>
  )
}

export default ModalAlert;